<script setup>
  import { computed } from 'vue';
  import SpotListRow from '@/components/SpotListRow.vue';
  import BannerAd from '@/components/BannerAd.vue'

  const props = defineProps({
    data: {
      type: Object,
      default: null
    },
    showObsGraph: {
      type: Boolean,
      default: true
    },
    showForecastGraph: {
      type: Boolean,
      default: true
    },
    showDistance: {
      type: Boolean,
      default: false
    },
    showLinkIcon: {
      type: Boolean,
      default: true
    },
    showLocalTimestamp: {
      type: Boolean,
      default: true
    },
    showModelData: {
      type: Boolean,
      default: false
    },
    sort: {
      type: String,
      default: 'distance'
    },
    showAds: {
      type: Boolean,
      default: false
    },
  });

  const adCount = computed(() => {
    const spotCount = props.data.length;

    if (spotCount < 24) return 0;

    return Math.floor((spotCount - 12) / 12);
  });

  const rows = computed(() => {
    const rows = [];
    let adsPlacedCount = 0;

    for (let i = 0; i < props.data.length; i++) {
      const spot = props.data[i];

      if (props.showAds && i % 12 === 0 && adsPlacedCount < adCount.value && i !== 0) {
        rows.push({ type: 'ad', index:  adsPlacedCount, id: adsPlacedCount++});
      } else {
        rows.push({ type: 'spot', index: i, id: spot.id})
      }
    }

    return rows;
  })

</script>

<template>
  <div class="jwx-spot-list-container">
    <p v-if="data.length === 0" class="jwx-spot-list-message">No weather stations found.</p>

    <div v-else>
      <ul class="jwx-spot-list">
        <li
          v-for="row in rows"
          class="jwx-spot-list__item"
          :key="row.id"
        >
          <SpotListRow
            v-if="row.type === 'spot'"
            :spot="props.data[row.index]"
            :showLocalTimestamp="props.showLocalTimestamp"
            :showDistance="props.showDistance"
          />
          <BannerAd
            v-else
            type="mid"
          />
        </li>

      </ul>
    </div>
  </div>
</template>
